import PubSub from "underpub-js";
import URI from "urijs";
import Cookies from 'js-cookie';
import ConsentedCookie from '../../../../scripts/classes/ConsentedCookie';
import LocaleHost from '../../../../scripts/classes/LocaleHost';
import jstree from 'jstree';
import gsap from 'gsap';

// Breakpoints considered as "mobile" for the active filter tags display
const MOBILE_BREAKPOINTS = ['xsmall', 'small'];
import ScrollToPlugin from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollToPlugin);

var Directory = function(options) {

	this.options = {
		$el: false,
		baseClass: 'comp-Directory',
	};

	$.extend(true, this.options, options);

};

/*
 *	Init function
 */
Directory.prototype.init = function() {

	var self = this;

	// dom elements
	this.$keywordSearchInputs = self.options.$el.find(`.${self.options.baseClass}__keywordSearch__keywordSearchInput`);
	this.$keywordSearchInput = this.options.$el.find(`.${self.options.baseClass}__keywordSearchWrapper .${self.options.baseClass}__keywordSearch__keywordSearchInput`);
	this.$mobileKeywordSearchInput = this.options.$el.find(`.${self.options.baseClass}__keywordSearchWrapper--mobile .${self.options.baseClass}__keywordSearch__keywordSearchInput`);
	this.$filterWrappers = this.options.$el.find(`.${self.options.baseClass}__dropdownFilterWrapper`);
	
	this.$expertiseFilter = this.options.$el.find(`.${self.options.baseClass}__dropdownFilter--expertise .${self.options.baseClass}__dropdownFilter__filter`);
	this.$expertiseFilterWrapper = this.options.$el.find(`.${self.options.baseClass}__dropdownFilter--expertise`);
	this.$locationFilter = this.options.$el.find(`.${self.options.baseClass}__dropdownFilter--location .${self.options.baseClass}__dropdownFilter__filter`);
	this.$locationFilterWrapper = this.options.$el.find(`.${self.options.baseClass}__dropdownFilter--location`);
	this.$leadershipFilter = this.options.$el.find(`.${self.options.baseClass}__dropdownFilter--leadership .${self.options.baseClass}__dropdownFilter__filter`);
	this.$leadershipFilterWrapper = this.options.$el.find(`.${self.options.baseClass}__dropdownFilter--leadership`);
	this.$lastNameFilter = this.options.$el.find(`.${self.options.baseClass}__dropdownFilter--lastName .${self.options.baseClass}__dropdownFilter__filter`);
	this.$lastNameFilterWrapper = this.options.$el.find(`.${self.options.baseClass}__dropdownFilter--lastName`);

	this.expertiseFilterDefaultText = 'Filter by Expertise';
	this.locationFilterDefaultText = 'Filter by Location';
	this.leadershipFilterDefaultText = 'Filter by Leadership';
	this.lastNameFilterDefaultText = 'Filter by Last Name';

	this.$dropdownFilterHeadings = this.options.$el.find(`.${self.options.baseClass}__dropdownFilter__heading`);
	this.$filterButtonWrapper = this.options.$el.find(`.${self.options.baseClass}__submitFiltersButton`);
	this.$filterButton = this.options.$el.find(`.${self.options.baseClass}__submitFiltersButton button`);
	this.$filterCollapseTrigger = this.options.$el.find(`.${self.options.baseClass}__filterCollapseTrigger`);
	this.$filterCollapseWrapper = this.options.$el.find(`.${self.options.baseClass}__filterCollapseWrapper`);
	this.$filterCollapseIndicator = this.$filterCollapseTrigger.find(`.${self.options.baseClass}__filterCollapseTrigger__openCloseIndicator span`).eq(0);
	this.$activeFilterTagsWrapper = this.options.$el.find(`.${self.options.baseClass}__activeFilterTags`);
	this.$heightAdjustWrapper = this.options.$el.find(`.${self.options.baseClass}__resultsPaginationWrapper`);
	this.$paginationWrapper = this.options.$el.find(`.${self.options.baseClass}__pagination`);
	this.$placeholdersContainer = this.options.$el.find(`.${self.options.baseClass}__results--placeholders`);
	this.$resultsContainer = this.options.$el.find(`.${self.options.baseClass}__results--container`);
	this.$noResultsContainer = this.options.$el.find(`.${self.options.baseClass}__results--noResults`);
	this.$personResultTemplate = this.options.$el.find(`.${self.options.baseClass}__resultWrapper--resultTemplate`);
	this.$filtersLoader = this.options.$el.find(`.${self.options.baseClass}__filtersLoader`);
	this.$clearFiltersButton = this.options.$el.find(`.${self.options.baseClass}__clearFiltersButton`);

	this.selectedDropdownFilterClass = `${self.options.baseClass}__dropdownFilter--selected`;

	// state variables
	this.loadStartTime = new Date().getTime() / 1000;

	// these variables will hold the most recently submitted search/filters, and will be used
	// by the pagination links
	this.submittedQuery = '';
	this.submittedExpertiseFilters = [];
	this.submittedLocationFilters = [];
	this.submittedLeadershipFilters = [];
	this.submittedLastNameFilters = [];

	// kick things off
	this.initFilters();
	this.initPagination();

	// get our URL parameters
	let searchParams = new URLSearchParams(window.location.search);

	// this boolean will track whether any filters were set via URL parameters
	let urlParametersSet = false;

	// check if expertise filter is being set via URL parameter
	if (searchParams.has('expertise')) {

		// expertise URL param is set, so update the filter before submitting
		let expertiseId = searchParams.get('expertise'); // get URL parameter value
	
		this.$expertiseFilter.jstree('open_all'); // open all nodes (they must be opened to check one)
		let expertiseNode = $(`[data-id="${expertiseId}"]`); // get the node by ID
		this.$expertiseFilter.jstree('select_node', expertiseNode); // select the node
		this.$expertiseFilter.jstree('close_all'); // close all nodes

		// remove the URL parameter so that if a person is clicked then the back button is used, filter updates will remain
		var state = {};
		var title = '';
		var currentUrlWithoutParams = location.protocol + '//' + location.host + location.pathname;
		var url = new URL( currentUrlWithoutParams );
		// url.searchParams.set('unitDetail', unitId);
		window.history.replaceState(state, title, url);

		urlParametersSet = true; // set our boolean so we know filters were set via URL parameter

	}

	// check if region filter is being set via URL parameter
	if (searchParams.has('region')) {

		// region URL param is set, so update the filter before submitting
		let regionName = searchParams.get('region');
	
		this.$locationFilter.jstree('open_all'); // open all nodes (they must be opened to check one)
		let regionNode = $(`[data-region="${regionName}"]`); // get the node by ID
		this.$locationFilter.jstree('select_node', regionNode); // select the node
		this.$locationFilter.jstree('close_all'); // close all nodes

		// remove the URL parameter so that if a person is clicked then the back button is used, filter updates will remain
		var state = {};
		var title = '';
		var currentUrlWithoutParams = location.protocol + '//' + location.host + location.pathname;
		var url = new URL( currentUrlWithoutParams );
		// url.searchParams.set('unitDetail', unitId);
		window.history.replaceState(state, title, url);

		urlParametersSet = true; // set our boolean so we know filters were set via URL parameter

	}

	// check if search box is being set via URL parameter
	if (searchParams.has('query')) {

		// region URL param is set, so update the filter before submitting
		let searchQuery = searchParams.get('query');
	
		this.$keywordSearchInput.val(searchQuery);
		this.$mobileKeywordSearchInput.val(searchQuery);

		// remove the URL parameter so that if a person is clicked then the back button is used, filter updates will remain
		var state = {};
		var title = '';
		var currentUrlWithoutParams = location.protocol + '//' + location.host + location.pathname;
		var url = new URL( currentUrlWithoutParams );
		// url.searchParams.set('unitDetail', unitId);
		window.history.replaceState(state, title, url);

		urlParametersSet = true; // set our boolean so we know filters were set via URL parameter

	}

	// check if any filters were set via URL parameter
	if (!urlParametersSet) {
		// no URL parameters were set

		// get our filter settings from cookies, so we can reload the previous directory state
		let savedQuery = Cookies.get('directoryQuery');
		let expertiseToSelect = Cookies.get('directoryExpertise');
		let locationToSelect = Cookies.get('directoryLocation');
		let currentRegion = Cookies.get('region');
		let leadershipToSelect = Cookies.get('directoryLeadership');
		let lastNameToSelect = Cookies.get('directoryLastName');

		// check if a search query was saved in cookies
		if (savedQuery) {
			this.$keywordSearchInput.val(savedQuery);
			this.$mobileKeywordSearchInput.val(savedQuery);
		}

		// check if an expertise filter value was saved in cookies
		if (expertiseToSelect) {

			let expertiseIds = expertiseToSelect.split('|');

			this.$expertiseFilter.jstree('open_all'); // open all nodes (they must be opened to check one)

			for (let i = 0; i < expertiseIds.length; i++) {
				
				let expertiseId = expertiseIds[i];
	
				let expertiseNode = $(`[data-id="${expertiseId}"]`); // get the node by ID
				this.$expertiseFilter.jstree('select_node', expertiseNode); // select the node

			}

			this.$expertiseFilter.jstree('close_all'); // close all nodes

		}

		// if region is set, filter by it
		if (currentRegion) {

			this.$locationFilter.jstree('open_all'); // open all nodes (they must be opened to check one)
			let regionNode = $(`[data-region="${currentRegion}"]`); // get the node by ID
			this.$locationFilter.jstree('select_node', regionNode); // select the node
			this.$locationFilter.jstree('close_all'); // close all nodes

		}
		// if location was previously selected, set back to that value
		else if (locationToSelect) {

			let locationIds = locationToSelect.split('|');

			this.$locationFilter.jstree('open_all'); // open all nodes (they must be opened to check one)

			for (let i = 0; i < locationIds.length; i++) {
				
				let locationId = locationIds[i];
				let locationNode = $(`#${locationId}`); // get the node by ID

				this.$locationFilter.jstree('select_node', locationNode); // select the node

			}

			this.$locationFilter.jstree('close_all'); // close all nodes

		}

		if (leadershipToSelect) {

			let leadershipIds = leadershipToSelect.split('|');

			this.$leadershipFilter.jstree('open_all'); // open all nodes (they must be opened to check one)

			for (let i = 0; i < leadershipIds.length; i++) {
				
				let leadershipId = leadershipIds[i];
	
				let leadershipNode = $(`[data-id="${leadershipId}"]`); // get the node by ID
				this.$leadershipFilter.jstree('select_node', leadershipNode); // select the node

			}

			this.$leadershipFilter.jstree('close_all'); // close all nodes

		}

		if (lastNameToSelect) {

			let lastNameToSelectArray = lastNameToSelect.split('|');

			this.$lastNameFilter.jstree('open_all'); // open all nodes (they must be opened to check one)

			for (let i = 0; i < lastNameToSelectArray.length; i++) {
				
				let lastNameLetter = lastNameToSelectArray[i];
	
				let lastNameNode = $(`[data-filter-letter="${lastNameLetter}"]`); // get the node by ID
				this.$lastNameFilter.jstree('select_node', lastNameNode); // select the node

			}

			this.$lastNameFilter.jstree('close_all'); // close all nodes

		}

	}
	
	this.submitFilters();

	this.options.$el.on('click', '.comp-Directory__person__info__links__link--vcard', function() {

		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: 'download_vcard',
			event_category: 'engagement'
		});

	});
	
};

// this function initializes all of our filters
Directory.prototype.initFilters = function() {

	var self = this;

	this.$expertiseFilter.jstree({
		"core": {
			"themes": {
				"icons": false
			},
			"loaded_state": true
		},
		"checkbox" : {
			// cascade: 'down'
			// "keep_selected_style" : false
		},
		"plugins" : [ "checkbox" ]
	});

	this.$locationFilter.jstree({
		"core": {
			"themes": {
				"icons": false
			}
		},
		"checkbox" : {
			// cascade: 'down'
			// "keep_selected_style" : false
		},
		"plugins" : [ "checkbox", "sort" ]
	});

	this.$leadershipFilter.jstree({
		"core": {
			"themes": {
				"icons": false
			}
		},
		"checkbox" : {
			// cascade: 'down'
			// "keep_selected_style" : false
		},
		"plugins" : [ "checkbox" ]
	});

	this.$lastNameFilter.jstree({
		"core": {
			"themes": {
				"icons": false
			}
		},
		"checkbox" : {
			// cascade: 'down'
			// "keep_selected_style" : false
		},
		"plugins" : [ "checkbox" ]
	});

	// when a dropdown filter heading is clicked
	this.$dropdownFilterHeadings.on('click', function() {

		let $dropdownFilter = $(this).closest(`.${self.options.baseClass}__dropdownFilter`);

		// check if the filter is currently active, and toggle
		if ($dropdownFilter.hasClass(`${self.options.baseClass}__dropdownFilter--active`))
		{
			self.closeDropdownFilter($dropdownFilter);
		}
		else
		{
			self.openDropdownFilter($dropdownFilter);
		}
		
	});

	// setting up our timeline to open/close filters
	this.filterCollapseTimeline = gsap.timeline({
		defaults: {
			duration: 0.3
		}
	})
	.to(self.$filterCollapseIndicator, {
		rotation: 0,
		duration: 0.35,
		ease: "power1.inOut"
	}, 0)
	.to(self.$filterCollapseWrapper, {
		height: 'auto',
	}, 0).reverse();

	// when the filter show/hide button is clicked on mobile
	this.$filterCollapseTrigger.on('click', function() {
		self.filterCollapseTimeline.reversed(!self.filterCollapseTimeline.reversed());
	});

	// when the filter submit button is clicked
	this.$filterButton.on('click', function() {
		// set our loading state
		self.loading();
		self.submitFilters();
	});

	// when the enter key is pressed and the text search box has focus
	$(document).on('keypress',function(e) {
		if(e.which == 13) {
			if (self.$keywordSearchInput.is(":focus") || self.$mobileKeywordSearchInput.is(":focus")) {
				// set our loading state
				self.loading();
				self.submitFilters();
			}
		}
	});

	// make sure our mobile/desktop keyword search fields have the same value
	this.$keywordSearchInputs.on('input', function() {
		var value = $(this).val();
		self.$keywordSearchInputs.val(value);
		self.pulsateButton();
	});

	// when the clear filters button is clicked
	this.$clearFiltersButton.on('click', function() {
		self.clearAllFilters();
		// set our loading state
		self.loading();
		self.submitFilters();
	});

	// when a dropdown filter is changed
	this.$expertiseFilter.on('changed.jstree', function(e, data) {

		self.handleDropdownFilterChange($(this), data);

	});

	this.$locationFilter.on('changed.jstree', function(e, data) {

		self.handleDropdownFilterChange($(this), data);

	});

	this.$leadershipFilter.on('changed.jstree', function(e, data) {

		self.handleDropdownFilterChange($(this), data);

	});

	this.$lastNameFilter.on('changed.jstree', function(e, data) {

		self.handleDropdownFilterChange($(this), data);

	});

	// when clicking outside the filters, close them
	$(`body`).on('click', function() {
		
		if(window.Breakpoint.value != "xsmall" && window.Breakpoint.value != "small"){
			self.closeAllDropdownFilters();
		}

	});

	// when clicking a filter, don't close the filters (stops the above function from triggering)
	this.$filterWrappers.on('click', function(e) {
		e.stopPropagation();
	});

	// re-render active filter tags when the screen crosses the mobile/desktop breakpoint threshold
	// Note: we re-read jstree state directly instead of using stored node references,
	// because jstree may invalidate those references when the window resizes.
	let previousIsMobile = MOBILE_BREAKPOINTS.includes(window.Breakpoint.value);
	PubSub.subscribe('resized', function() {
		const currentIsMobile = MOBILE_BREAKPOINTS.includes(window.Breakpoint.value);
		if (currentIsMobile !== previousIsMobile) {
			previousIsMobile = currentIsMobile;
			self.updateActiveFilterTags(
				self.$keywordSearchInput.val(),
				self.$expertiseFilter.jstree('get_top_checked', true),
				self.$locationFilter.jstree('get_top_checked', true),
				self.$leadershipFilter.jstree('get_top_checked', true),
				self.$lastNameFilter.jstree('get_top_checked', true)
			);
		}
	});
	// when clicking an active filter tag, update the filters
	this.$activeFilterTagsWrapper.on('click', `.${self.options.baseClass}__activeFilterTag`, function() {

		let tagType = $(this).data('tagType');

		// determine which type of filter tag was clicked so we can clear the appropriate filter
		switch (tagType) {
			case 'query':
				self.clearKeywordSearch();
				break;
			case 'expertise':
				self.clearExpertiseFilter();
				break;
			case 'location':
				self.clearLocationFilter();
				break;
			case 'leadership':
				self.clearLeadershipFilter();
				break;
			case 'lastName':
				self.clearLastNameFilters();
				break;
		}

		// we use a timeline here so that the animation is smooth when a filter tag is clicked
		gsap.timeline()
		.to($(this), {
			duration: 0.25,
			opacity: 0
		})
		.add(function() {
			self.loading();
			self.submitFilters();
		});

	});

};

// this function handles a dropdown filter change
Directory.prototype.handleDropdownFilterChange = function($changedFilter, data) {

	var self = this;

	let $filterParent = $changedFilter.closest(`.${self.options.baseClass}__dropdownFilter`);

	if (data.selected.length) {
		$filterParent.addClass(self.selectedDropdownFilterClass);
	}
	else {
		$filterParent.removeClass(self.selectedDropdownFilterClass);
	}

	// jstree calls the change event in some situations where we don't want to pulsate the button, so we check
	// for those cases and exit early
	if (data.action == 'ready' || data.action == 'deselect_all') {
		return;
	}

	self.pulsateButton();

};

// Init our pagination links
Directory.prototype.initPagination = function() {

	var self = this;

	this.options.$el.on('click', `.${self.options.baseClass}__pagination__link`, function() {
		self.goToPage( $(this).data('page') );
	});

};

// Handles opening a dropdown filter
Directory.prototype.openDropdownFilter = function($dropdownFilter) {

	var self = this;

	let $filterWrapper = $dropdownFilter.find(`.${self.options.baseClass}__dropdownFilter__filterWrapper`);

	$dropdownFilter.addClass(`${self.options.baseClass}__dropdownFilter--active`);

	gsap.timeline()
	.set($filterWrapper, {
		overflow: 'hidden'
	})
	.to($filterWrapper, {
		height: 'auto',
		duration: 0.5,
	})
	.set($filterWrapper, {
		overflow: 'auto'
	});

};

// Closes all dropdown filters
Directory.prototype.closeAllDropdownFilters = function() {

	var self = this;

	this.options.$el.find(`.${self.options.baseClass}__dropdownFilter`).each(function() {

		self.closeDropdownFilter($(this));

	});

};

// Closes a dropdown filter
Directory.prototype.closeDropdownFilter = function($dropdownFilter) {

	var self = this;

	let $filterWrapper = $dropdownFilter.find(`.${self.options.baseClass}__dropdownFilter__filterWrapper`);

	$dropdownFilter.removeClass(`${self.options.baseClass}__dropdownFilter--active`);

	gsap.timeline()
	.set($filterWrapper, {
		overflow: 'hidden'
	})
	.to($filterWrapper, {
		height: 0,
		duration: 0.35,
	})
	.set($filterWrapper, {
		overflow: 'auto'
	});

};

// Clears all filters
Directory.prototype.clearAllFilters = function() {

	var self = this;

	this.clearKeywordSearch();
	this.clearExpertiseFilter();
	this.clearLocationFilter();
	this.clearLeadershipFilter();
	this.clearLastNameFilters();
	
};

// Clears the keyword search
Directory.prototype.clearKeywordSearch = function() {

	var self = this;
	this.$keywordSearchInput.val('');
	this.$mobileKeywordSearchInput.val('');

};

// Clears the expertise filter
Directory.prototype.clearExpertiseFilter = function() {

	var self = this;
	this.$expertiseFilter.jstree('deselect_all');

};

// Clears the location filter
Directory.prototype.clearLocationFilter = function() {

	var self = this;
	this.$locationFilter.jstree('deselect_all');

};

// Clears the leadership filter
Directory.prototype.clearLeadershipFilter = function() {

	var self = this;
	this.$leadershipFilter.jstree('deselect_all');

};

// Clears the last name filter
Directory.prototype.clearLastNameFilters = function() {

	var self = this;

	this.$lastNameFilter.jstree('deselect_all');

};

// gets our filter values and passes them to updatePeopleResults
Directory.prototype.submitFilters = function() {

	var self = this;

	// keyword search
	var query = this.$keywordSearchInput.val();

	ConsentedCookie.set('directoryQuery', query, 'functional');

	// expertise filters
	var selectedTopLevelExpertiseFilters = this.$expertiseFilter.jstree('get_top_checked', true);
	var selectedExpertiseFilters = this.$expertiseFilter.jstree('get_checked', true);
	var selectedExpertiseHeadingText = '';
	var selectedExpertiseIds = [];

	// for each selected expertise filter
	for (let i = 0; i < selectedExpertiseFilters.length; i++) {
		selectedExpertiseIds = [...new Set([...selectedExpertiseIds,...[selectedExpertiseFilters[i].data.id.toString()] ])]; // filter out duplicates
	}

	// getting our updated heading text
	for (let i = 0; i < selectedTopLevelExpertiseFilters.length; i++) {
		selectedExpertiseHeadingText += selectedTopLevelExpertiseFilters[i].text.trim();

		if (i < selectedTopLevelExpertiseFilters.length - 1) {
			selectedExpertiseHeadingText += ', ';
		}

	}

	// update the filter heading text
	if (selectedExpertiseHeadingText) {
		this.$expertiseFilterWrapper.find(`.${self.options.baseClass}__dropdownFilter__heading__text`).text(selectedExpertiseHeadingText);
	}
	else {
		this.$expertiseFilterWrapper.find(`.${self.options.baseClass}__dropdownFilter__heading__text`).text(this.expertiseFilterDefaultText);
	}

	// update expertise filters cookie
	ConsentedCookie.set('directoryExpertise', selectedExpertiseIds.join('|'), 'functional');

	// location filters
	var selectedTopLevelLocationFilters = this.$locationFilter.jstree('get_top_checked', true);
	var selectedLocationFilters = this.$locationFilter.jstree('get_bottom_checked', true);
	var selectedLocationHeadingText = '';
	var selectedLocationIds = [];
	var selectedLocationFilterIds = [];

	// for each selected location filter
	for (let i = 0; i < selectedLocationFilters.length; i++) {
		selectedLocationIds = [...new Set([...selectedLocationIds,...selectedLocationFilters[i].data.branches])]; // filter out duplicates
		selectedLocationFilterIds.push(selectedLocationFilters[i].id); // filter out duplicates
	}

	// getting our updated heading text
	for (let i = 0; i < selectedTopLevelLocationFilters.length; i++) {
		selectedLocationHeadingText += selectedTopLevelLocationFilters[i].text.trim();

		if (i < selectedTopLevelLocationFilters.length - 1) {
			selectedLocationHeadingText += ', ';
		}

	}

	// update the filter heading text
	if (selectedLocationHeadingText) {
		this.$locationFilterWrapper.find(`.${self.options.baseClass}__dropdownFilter__heading__text`).text(selectedLocationHeadingText);
	}
	else {
		this.$locationFilterWrapper.find(`.${self.options.baseClass}__dropdownFilter__heading__text`).text(this.locationFilterDefaultText);
	}

	// update location filters cookie
	ConsentedCookie.set('directoryLocation', selectedLocationFilterIds.join('|'), 'functional');

	// leadership filters
	var selectedTopLevelLeadershipFilters = this.$leadershipFilter.jstree('get_top_checked', true);
	var selectedLeadershipFilters = this.$leadershipFilter.jstree('get_bottom_checked', true);
	var selectedLeadershipHeadingText = '';
	var selectedLeadershipIds = [];

	// for each selected leadership filter
	for (let i = 0; i < selectedLeadershipFilters.length; i++) {
		selectedLeadershipIds = [...new Set([...selectedLeadershipIds,...[selectedLeadershipFilters[i].data.id.toString()] ])]; // filter out duplicates
	}

	// getting our updated heading text
	for (let i = 0; i < selectedTopLevelLeadershipFilters.length; i++) {
		selectedLeadershipHeadingText += selectedTopLevelLeadershipFilters[i].text.trim();

		if (i < selectedTopLevelLeadershipFilters.length - 1) {
			selectedLeadershipHeadingText += ', ';
		}

	}

	// update the filter heading text
	if (selectedLeadershipHeadingText) {
		this.$leadershipFilterWrapper.find(`.${self.options.baseClass}__dropdownFilter__heading__text`).text(selectedLeadershipHeadingText);
	}
	else {
		this.$leadershipFilterWrapper.find(`.${self.options.baseClass}__dropdownFilter__heading__text`).text(this.leadershipFilterDefaultText);
	}

	// update leadership filters cookie
	ConsentedCookie.set('directoryLeadership', selectedLeadershipIds.join('|'), 'functional');

	// last name filters
	var selectedTopLevelLastNameFilters = this.$lastNameFilter.jstree('get_top_checked', true);
	var selectedLastNameFilters = this.$lastNameFilter.jstree('get_bottom_checked', true);
	var selectedLastNameHeadingText = '';
	var selectedLastNameLetters = [];

	// for each selected last name filter
	for (let i = 0; i < selectedLastNameFilters.length; i++) {
		selectedLastNameLetters = [...new Set([...selectedLastNameLetters,...[selectedLastNameFilters[i].data.filterLetter] ])]; // filter out duplicates
	}

	// getting our updated heading text
	for (let i = 0; i < selectedTopLevelLastNameFilters.length; i++) {
		selectedLastNameHeadingText += selectedTopLevelLastNameFilters[i].text.trim();

		if (i < selectedTopLevelLastNameFilters.length - 1) {
			selectedLastNameHeadingText += ', ';
		}

	}

	// update the filter heading text
	if (selectedLastNameHeadingText) {
		this.$lastNameFilterWrapper.find(`.${self.options.baseClass}__dropdownFilter__heading__text`).text(selectedLastNameHeadingText);
	}
	else {
		this.$lastNameFilterWrapper.find(`.${self.options.baseClass}__dropdownFilter__heading__text`).text(this.lastNameFilterDefaultText);
	}

	// update last name filters cookie
	ConsentedCookie.set('directoryLastName', selectedLastNameLetters.join('|'), 'functional');

	this.stopButtonPulsate();

	// now we pass all of our values off to the functions that do the work

	// save the last submitted top-level filter values so we can re-render filter tags on resize
	this.submittedQuery = query;
	this.submittedExpertiseFilters = selectedTopLevelExpertiseFilters;
	this.submittedLocationFilters = selectedTopLevelLocationFilters;
	this.submittedLeadershipFilters = selectedTopLevelLeadershipFilters;
	this.submittedLastNameFilters = selectedTopLevelLastNameFilters;

	this.updateActiveFilterTags(query, selectedTopLevelExpertiseFilters, selectedTopLevelLocationFilters, selectedTopLevelLeadershipFilters, selectedTopLevelLastNameFilters);

	this.updatePeopleResults(query, selectedExpertiseIds, selectedLocationIds, selectedLeadershipIds, selectedLastNameLetters);

};

// this function updates the filter tags
Directory.prototype.updateActiveFilterTags = function(query, expertiseFilters, locationFilters, leadershipFilters, lastNameFilters) {

	var self = this;

	gsap.set(self.$activeFilterTagsWrapper, {
		height: self.$activeFilterTagsWrapper.height()
	});

	gsap.timeline()
	.to(self.options.$el.find(`.${self.options.baseClass}__activeFilterTag`), {
		opacity: 0,
		duration: 0.2
	})
	.add(function() {
		self.addAllActiveFilterTags(query, expertiseFilters, locationFilters, leadershipFilters, lastNameFilters);
	});

};

// this function adds all the active filter tags
Directory.prototype.addAllActiveFilterTags = function(query, expertiseFilters, locationFilters, leadershipFilters, lastNameFilters) {

	var self = this;

	this.$activeFilterTagsWrapper.empty(); // clear out any existing filter tags

	// query filter tag
	if (query) {
		self.addActiveFilterTag('Search: '+query, 'query');
	}

	// expertise filter tag
	if (expertiseFilters.length) {

		let expertiseFiltersString = 'Expertise: ';
		let fullExpertiseFiltersString = 'Expertise: ';
		const isMobile = MOBILE_BREAKPOINTS.includes(window.Breakpoint.value);
	
		for (let i = 0; i < expertiseFilters.length; i++) {
			const expertiseFilter = expertiseFilters[i];

			if (isMobile) {
				// Mobile: compact format — «filtre_1 or N others»
				if (expertiseFilters.length < 3) {
					if (i > 0) {
						expertiseFiltersString += ` <span class="${self.options.baseClass}__activeFilterTag__value__separator">or</span> `;
					}
					expertiseFiltersString += expertiseFilter.text;
				} else {
					if (i == 0) {
						expertiseFiltersString = `Expertise: ${expertiseFilter.text} <span class="${self.options.baseClass}__activeFilterTag__value__separator">or</span> ` + (expertiseFilters.length-1) + ` others`;
					}
				}
			} else {
				// Desktop: full format — «filtre_1 or filtre_2 or filtre_xx»
				if (i > 0) {
					expertiseFiltersString += ` <span class="${self.options.baseClass}__activeFilterTag__value__separator">or</span> `;
				}
				expertiseFiltersString += expertiseFilter.text;
			}

			// full expertise string for title attribute
			if (i > 0) {
				fullExpertiseFiltersString += ` or `;
			}
			fullExpertiseFiltersString += expertiseFilter.text.trim();

		}

		self.addActiveFilterTag(expertiseFiltersString, 'expertise', fullExpertiseFiltersString);

	}

	// location filter tag
	if (locationFilters.length) {
		
		let locationFiltersString = 'Location: ';
		let fullLocationFiltersString = 'Location: ';
		const isMobile = MOBILE_BREAKPOINTS.includes(window.Breakpoint.value);
	
		for (let i = 0; i < locationFilters.length; i++) {
			const locationFilter = locationFilters[i];

			if (isMobile) {
				// Mobile: compact format — «filtre_1 or N others»
				if (locationFilters.length < 3) {
					if (i > 0) {
						locationFiltersString += ` <span class="${self.options.baseClass}__activeFilterTag__value__separator">or</span> `;
					}
					locationFiltersString += locationFilter.text;
				} else {
					if (i == 0) {
						locationFiltersString = `Location: ${locationFilter.text} <span class="${self.options.baseClass}__activeFilterTag__value__separator">or</span> ` + (locationFilters.length-1) + ` others`;
					}
				}
			} else {
				// Desktop: full format — «filtre_1 or filtre_2 or filtre_xx»
				if (i > 0) {
					locationFiltersString += ` <span class="${self.options.baseClass}__activeFilterTag__value__separator">or</span> `;
				}
				locationFiltersString += locationFilter.text;
			}

			// full location string for title attribute
			if (i > 0) {
				fullLocationFiltersString += ` or `;
			}
			fullLocationFiltersString += locationFilter.text.trim();

		}

		self.addActiveFilterTag(locationFiltersString, 'location', fullLocationFiltersString);

	}

	// leadership filter tag
	if (leadershipFilters.length) {
	
		let leadershipFiltersString = 'Leadership: ';
		let fullLeadershipFiltersString = 'Leadership: ';
		const isMobile = MOBILE_BREAKPOINTS.includes(window.Breakpoint.value);
	
		for (let i = 0; i < leadershipFilters.length; i++) {
			const leadershipFilter = leadershipFilters[i];

			if (isMobile) {
				// Mobile: compact format — «filtre_1 or N others»
				if (leadershipFilters.length < 3) {
					if (i > 0) {
						leadershipFiltersString += ` <span class="${self.options.baseClass}__activeFilterTag__value__separator">or</span> `;
					}
					leadershipFiltersString += leadershipFilter.text;
				} else {
					if (i == 0) {
						leadershipFiltersString = `Leadership: ${leadershipFilter.text} <span class="${self.options.baseClass}__activeFilterTag__value__separator">or</span> ` + (leadershipFilters.length-1) + ` others`;
					}
				}
			} else {
				// Desktop: full format — «filtre_1 or filtre_2 or filtre_xx»
				if (i > 0) {
					leadershipFiltersString += ` <span class="${self.options.baseClass}__activeFilterTag__value__separator">or</span> `;
				}
				leadershipFiltersString += leadershipFilter.text;
			}

			// full leadership string for title attribute
			if (i > 0) {
				fullLeadershipFiltersString += ` or `;
			}
			fullLeadershipFiltersString += leadershipFilter.text.trim();

		}

		self.addActiveFilterTag(leadershipFiltersString, 'leadership', fullLeadershipFiltersString);

	}

	// last name filter tag
	if (lastNameFilters.length) {

		let lastNameFiltersString = 'Last Name: ';
		let fullLastNameFiltersString = 'Last Name: ';
		const isMobile = MOBILE_BREAKPOINTS.includes(window.Breakpoint.value);
		
		// get letters into an array so we can sort them
		let selectedLastNameLettersArray = [];
		for (let i = 0; i < lastNameFilters.length; i++) {
			const lastNameFilter = lastNameFilters[i];
			selectedLastNameLettersArray.push(lastNameFilter.text);
		}
		selectedLastNameLettersArray.sort();
	
		for (let i = 0; i < selectedLastNameLettersArray.length; i++) {
			const lastNameLetter = selectedLastNameLettersArray[i];

			if (isMobile) {
				// Mobile: compact format — «filtre_1 or N others»
				if (selectedLastNameLettersArray.length < 3) {
					if (i > 0) {
						lastNameFiltersString += ` <span class="${self.options.baseClass}__activeFilterTag__value__separator">or</span> `;
					}
					lastNameFiltersString += lastNameLetter;
				} else {
					if (i == 0) {
						lastNameFiltersString = `Last Name: ${lastNameLetter} <span class="${self.options.baseClass}__activeFilterTag__value__separator">or</span> ` + (selectedLastNameLettersArray.length-1) + ` others`;
					}
				}
			} else {
				// Desktop: full format — «filtre_1 or filtre_2 or filtre_xx»
				if (i > 0) {
					lastNameFiltersString += ` <span class="${self.options.baseClass}__activeFilterTag__value__separator">or</span> `;
				}
				lastNameFiltersString += lastNameLetter;
			}

			// full last name string for title attribute
			if (i > 0) {
				fullLastNameFiltersString += ` or `;
			}
			fullLastNameFiltersString += lastNameLetter;

		}

		self.addActiveFilterTag(lastNameFiltersString, 'lastName', fullLastNameFiltersString);

	}

	// timeline that handles fading in our filter tags
	gsap.timeline()
	.to(self.$activeFilterTagsWrapper, {
		height: "auto",
		duration: 0.2
	})
	.fromTo(self.options.$el.find(`.${self.options.baseClass}__activeFilterTag`), {
		opacity: 0,
		scale: 0.92
	},
	{
		duration: 0.4,
		opacity: 1,
		scale: 1,
		stagger: {
			each: 0.08
		}
	});

};

// handles creating the dom element for a filter tag and adding it to the page
Directory.prototype.addActiveFilterTag = function(tagText, tagType, tagTitle) {

    var self = this;

    let $activeFilterTagElement = $('<div>', {
        'class': `${self.options.baseClass}__activeFilterTag`,
        'data-tag-type': tagType,
        'title': tagTitle
    });

    $activeFilterTagElement.append(
        $('<span>', { 'class': `${self.options.baseClass}__activeFilterTag__closeX` })
    );

    let $tagValueElement = $('<span>', {
        'class': `${self.options.baseClass}__activeFilterTag__value`
    });

    $tagValueElement.empty().append($.parseHTML(tagText)); 
    $activeFilterTagElement.append($tagValueElement);

    this.$activeFilterTagsWrapper.append($activeFilterTagElement);

};

// this function takes values for all filters and updates the people results
Directory.prototype.updatePeopleResults = function(query, expertiseFilters, locationFilters, leadershipFilters, lastNameFilters, pageNumber) {

	var self = this;

	this.submittedQuery = query;
	this.submittedExpertiseFilters = expertiseFilters;
	this.submittedLocationFilters = locationFilters;
	this.submittedLeadershipFilters = leadershipFilters;
	this.submittedLastNameFilters = lastNameFilters;

	// setting our ajax data that will be passed to our helper
	var ajaxData = {
		query: query,
		expertiseFilters: JSON.stringify(expertiseFilters),
		locationFilters: JSON.stringify(locationFilters),
		leadershipFilters: JSON.stringify(leadershipFilters),
		lastNameFilters: JSON.stringify(lastNameFilters),
		pageNumber: pageNumber,
	};

	// making an ajax call to our helpers module that does the actual work
	$.ajax({

		contentType: "application/json",
		url: '/actions/held-helpers-module/default/get-filtered-people',

		data: ajaxData,

		success: function(data) {
			self.doneLoading(data);
		},

		error: function(data) {
			console.log('AJAX error');
			console.log(data);
		}

	});

};

// this function handles pagination
Directory.prototype.goToPage = function(pageNumber) {

	var self = this;

	// set our loading state
	this.loading();

	// we use our update people results method here, we're not using craft built in pagination but instead
	// we handle pagination inside our helper module
	this.updatePeopleResults(this.submittedQuery, this.submittedExpertiseFilters, this.submittedLocationFilters, this.submittedLeadershipFilters, this.submittedLastNameFilters, pageNumber);

};

// this function sets the directory to the loading state
Directory.prototype.loading = function() {

	var self = this;

	// set loadStartTime to the current time, this will be used to make sure the loading state is given enough time
	// for the animations to appear properly
	this.loadStartTime = new Date().getTime() / 1000;

	// close our dropdown filters
	self.closeAllDropdownFilters();

	// set our height wrapper to a static height so it can be animated to auto
	var currentHeight = this.$heightAdjustWrapper.outerHeight();
	gsap.set(self.$heightAdjustWrapper, {
		height: currentHeight
	});

	// if we're scrolled down, scroll the user back to the top of the results - this is primarily used when the user
	// clicks a pagination link
	if ($(document).scrollTop() > self.options.$el.offset().top) {
		gsap.to(window, {duration: 0.8, scrollTo: self.options.$el.offset().top});
	}

	// our loading timeline
	gsap.timeline({

	})
	.add(function() {
		// set the submit button to the loading state
		let buttonLoadingClass = `${self.options.baseClass}__submitFiltersButton--loading`;
		self.$filterButtonWrapper.addClass(buttonLoadingClass);
	})
	// show our filters loader (the overlay over the filters that disallows them from being changed while loading)
	.set(self.$filtersLoader, {
		display: 'block'
	})
	.to(self.$filtersLoader, {
		opacity: 1
	})
	// fade out the results containers
	.to(self.$resultsContainer, {
		duration: 0.15,
		opacity: 0
	}, 0)
	.set(self.$resultsContainer, {
		display: 'none'
	})
	.to(self.$noResultsContainer, {
		duration: 0.15,
		opacity: 0
	}, 0)
	.set(self.$noResultsContainer, {
		display: 'none'
	})
	// fade out the pagination wrapper
	.to(self.$paginationWrapper, {
		duration: 0.15,
		opacity: 0
	}, 0)
	.set(self.$paginationWrapper, {
		display: 'none'
	})
	// show our placeholders while loading
	.set(self.$placeholdersContainer, {
		display: 'flex'
	}, 0.15)
	// animate our wrapper to the current height
	.to(self.$heightAdjustWrapper, {
		duration: 0.2,
		height: "auto"
	}, ">-0.05")
	.fromTo(self.$placeholdersContainer,
		{
			opacity: 0
		},
		{
			duration: 0.35,
			opacity: 1
		}
		, ">-0.05"
	);

	// .to(self.$placeholdersContainer, {
	// 	duration: 0.3,
	// 	opacity: 1
	// }, ">-0.05");

};

// this function is called when loading is complete
Directory.prototype.doneLoading = function(data) {

	var self = this;

	var pageInfo = data.pageInfo;
	var peopleData = data.people;

	var currTime = new Date().getTime() / 1000;

	// make sure loading took long enough to show all of the loading animations
	if ((currTime - this.loadStartTime) < 0.8)
	{
		setTimeout(function() { self.doneLoading(data); }, 250);
		return;
	}

	// if no results were found
	if (peopleData.length < 1) {
		self.noResults();
		return;
	}

	// update our dom elements
	this.updatePeopleResultsDom(peopleData);
	this.updatePaginationDom(pageInfo.currentPage, pageInfo.totalPages);

	// set our height wrapper to a static height so it can be animated to auto
	var currentHeight = this.$heightAdjustWrapper.outerHeight();
	gsap.set(self.$heightAdjustWrapper, {
		height: currentHeight
	});

	// run our done loading animations
	var doneLoadingTimeline = gsap.timeline({

	})
	// hide our filters loader (the overlay over the filters that disallows them from being changed while loading)
	.to(self.$filtersLoader, {
		duration: 0.5,
		opacity: 0
	})
	.set(self.$filtersLoader, {
		display: 'none'
	})
	// remove the loading state from the submit button
	.add(function() {
		let buttonLoadingClass = `${self.options.baseClass}__submitFiltersButton--loading`;
		self.$filterButtonWrapper.removeClass(buttonLoadingClass);
	})
	// hide the placeholders
	.to(self.$placeholdersContainer, {
		duration: 0.5,
		opacity: 0
	}, 0)
	.set(self.$placeholdersContainer, {
		display: 'none'
	})
	// fade in the results container
	.set(self.$resultsContainer, {
		display: 'flex',
		opacity: 1
	});

	// if there is multiple pages, show the pagination
	if (pageInfo.totalPages > 1) {

		doneLoadingTimeline
		.set(self.$paginationWrapper, {
			display: 'flex'
		});

	}
	// otherwise, hide the pagination
	else {

		doneLoadingTimeline
		.set(self.$paginationWrapper, {
			display: 'none'
		});

	}

	// animate our wrapper to the current height
	doneLoadingTimeline
	.to(self.$heightAdjustWrapper, {
		duration: 0.2,
		height: "auto"
	});

	// animate in each of our results in a staggered fashion
	doneLoadingTimeline
	.fromTo(self.$resultsContainer.find(`.${self.options.baseClass}__resultWrapper`),
		{
			opacity: 0,
			scale: 0.92
		},
		{
			duration: 0.4,
			opacity: 1,
			scale: 1,
			stagger: {
				each: 0.08
			}
		}
	);

	// if there are multiple pages, fade in the pagination
	if (pageInfo.totalPages > 1) {

		doneLoadingTimeline
		.fromTo(self.$paginationWrapper,
			{
				opacity: 0
			},
			{
				opacity: 1
			}, "<"
		);

	}

};

// this function updates the pagination dom elements
Directory.prototype.updatePaginationDom = function(currentPage, totalPages) {

	var self = this;

	this.$paginationWrapper.removeClass(`${self.options.baseClass}__pagination--hidden`);

	// if there is only a single page, hide the pagination
	if (totalPages == 1) {
		this.$paginationWrapper.addClass(`${self.options.baseClass}__pagination--hidden`);
		return;
	}

	currentPage = parseInt(currentPage);
	totalPages = parseInt(totalPages);

	// clear out the pagination wrapper to get it ready for new dom elements
	this.$paginationWrapper.empty();

	// the rest of the blocks in this function are similar to how we handle pagination in a craft template - they handle the logic
	// of setting up our pagination dom elements based on how many pages there are and what page we are currently on.

	if (currentPage != 1) {
		this.$paginationWrapper.append(
			`<div data-page="${currentPage-1}" class="${self.options.baseClass}__pagination__link ${self.options.baseClass}__pagination__link--previous">Prev</div>`
		);
	}

	if (currentPage > 1) {
		this.$paginationWrapper.append(
			`<div data-page="1" class="${self.options.baseClass}__pagination__link">1</div>`
		);
	}

	if (currentPage == 3) {
		this.$paginationWrapper.append(
			`<div data-page="2" class="${self.options.baseClass}__pagination__link">2</div>`
		);
	}

	if (currentPage == 4) {
		this.$paginationWrapper.append(
			`<div data-page="2" class="${self.options.baseClass}__pagination__link">2</div>
			<div data-page="3" class="${self.options.baseClass}__pagination__link">3</div>`
		);
	}

	if (currentPage > 4) {
		this.$paginationWrapper.append(
			`<div class="${self.options.baseClass}__pagination__link ${self.options.baseClass}__pagination__link--separator">...</div>
			<div data-page="${currentPage-2}" class="${self.options.baseClass}__pagination__link">${currentPage-2}</div>
			<div data-page="${currentPage-1}" class="${self.options.baseClass}__pagination__link">${currentPage-1}</div>`
		);
	}

	this.$paginationWrapper.append(
		`<div class="${self.options.baseClass}__pagination__link ${self.options.baseClass}__pagination__link--current">${currentPage}</div>`
	);

	if (totalPages - currentPage > 3) {
		this.$paginationWrapper.append(
			`<div data-page="${currentPage+1}" class="${self.options.baseClass}__pagination__link">${currentPage+1}</div>
			<div data-page="${currentPage+2}" class="${self.options.baseClass}__pagination__link">${currentPage+2}</div>
			<div class="${self.options.baseClass}__pagination__link ${self.options.baseClass}__pagination__link--separator">...</div>`
		);
	}

	if (totalPages - currentPage == 3) {
		this.$paginationWrapper.append(
			`<div data-page="${currentPage+1}" class="${self.options.baseClass}__pagination__link">${currentPage+1}</div>
			<div data-page="${currentPage+2}" class="${self.options.baseClass}__pagination__link">${currentPage+2}</div>`
		);
	}

	if (totalPages - currentPage == 2) {
		this.$paginationWrapper.append(
			`<div data-page="${currentPage+1}" class="${self.options.baseClass}__pagination__link">${currentPage+1}</div>`
		);
	}

	if (totalPages - currentPage > 0) {
		this.$paginationWrapper.append(
			`<div data-page="${totalPages}" class="${self.options.baseClass}__pagination__link">${totalPages}</div>`
		);
	}

	if (currentPage != totalPages) {
		this.$paginationWrapper.append(
			`<div data-page="${currentPage+1}" class="${self.options.baseClass}__pagination__link ${self.options.baseClass}__pagination__link--next">Next</div>`
		);
	}

};

// update our people results dom elements
Directory.prototype.updatePeopleResultsDom = function(peopleData) {

	var self = this;

	// clear out our results container to get it ready to fill in with new dom elements
	this.$resultsContainer.empty();

	// for each person result
	for (let i = 0; i < peopleData.length; i++) {
		
		// get our person result dom element
		let $personDomElement = self.getPersonDomElement(peopleData[i]);
		
		// add the dom element to the results container
		this.$resultsContainer.append($personDomElement);

	}

};

// this function is used when there are no results
Directory.prototype.noResults = function(personData) {

	var self = this;

	// set our height wrapper to a static height so it can be animated to auto
	var currentHeight = this.$heightAdjustWrapper.outerHeight();
	gsap.set(self.$heightAdjustWrapper, {
		height: currentHeight
	});

	// our animation timeline for when there are no results
	var noResultsTimeline = gsap.timeline({

	})
	// hide our filters loader (the overlay over the filters that disallows them from being changed while loading)
	.to(self.$filtersLoader, {
		duration: 0.5,
		opacity: 0
	})
	.set(self.$filtersLoader, {
		display: 'none'
	})
	// remove the loading state from the submit button
	.add(function() {
		let buttonLoadingClass = `${self.options.baseClass}__submitFiltersButton--loading`;
		self.$filterButtonWrapper.removeClass(buttonLoadingClass);
	})
	// fade out our placeholders
	.to(self.$placeholdersContainer, {
		duration: 0.5,
		opacity: 0
	}, 0)
	.set(self.$placeholdersContainer, {
		display: 'none'
	})
	// show the no results container that indicates to the user that there are no results
	.set(self.$noResultsContainer, {
		display: 'flex'
	})
	// hide the pagination
	.set(self.$paginationWrapper, {
		display: 'none'
	})
	// set the wrapper to the current height
	.to(self.$heightAdjustWrapper, {
		duration: 0.2,
		height: "auto"
	})
	// fade in the no results container that indicates to the user that there are no results
	.to(self.$noResultsContainer,
		{
			duration: 0.4,
			opacity: 1
		}
	);

};

// this function handles creating individual person result dom elements
Directory.prototype.getPersonDomElement = function(personData) {

	var self = this;

	// clone our person result template
	var $personDomElement = this.$personResultTemplate.clone()
		.removeClass(`${self.options.baseClass}__resultWrapper--resultTemplate`);

	// if this is a translated site, format the person URL accordingly
	if (LocaleHost.isAllowedHost(window.location.hostname)) {
		personData.url = LocaleHost.localizeUrl(personData.url, window.location.hostname);
	}
	
	// person image
	$personDomElement.find(`.${self.options.baseClass}__person__imageLink`).attr('href', personData.url);
	if (personData.headshot.length > 0) {
		$personDomElement.find(`.${self.options.baseClass}__person__imageLink__image`).css('background-image', 'url('+personData.headshot[0].url+')');
	}

	// person name
	$personDomElement.find(`.${self.options.baseClass}__person__info__name`).text(personData.title).attr('href', personData.url);
	
	// person job title
	if (personData.position) {
		$personDomElement.find(`.${self.options.baseClass}__person__info__jobTitle`).text(personData.position);
	}
	else {
		$personDomElement.find(`.${self.options.baseClass}__person__info__jobTitle`).remove();
	}

	// person location
	if (personData.city_state) {
		$personDomElement.find(`.${self.options.baseClass}__person__info__location`).text(personData.city_state);
	}
	else {
		$personDomElement.find(`.${self.options.baseClass}__person__info__location`).remove();
	}

	// person phone numbers
	if (!personData.phone_numbers.length > 0 && !personData.email) {
		$personDomElement.find(`.${self.options.baseClass}__person__info__contactInfo`).remove();
	}
	else {
		
		if (personData.phone_numbers.length > 0) {

			$personDomElement.find(`.${self.options.baseClass}__person__info__contactInfo__phone`).text('');

			var phoneNumbersString = '';

			// there can be multiple phone numbers, so this requires some specialized logic
			for (let i = 0; i < personData.phone_numbers.length; i++) {
				let phoneNumber = personData.phone_numbers[i].number;
				let phoneNumberType = personData.phone_numbers[i].label[0].toUpperCase() + personData.phone_numbers[i].label.substring(1);

				if (phoneNumberType == 'Work') {
					phoneNumbersString += 'Office: ';
				}
				else {
					phoneNumbersString += phoneNumberType + ': ';
				}

				phoneNumbersString += `<a href="tel:${phoneNumber}">` + phoneNumber + '</a>';

				if (i != personData.phone_numbers.length - 1) {
					phoneNumbersString += '<br>';
				}

			}

			$personDomElement.find(`.${self.options.baseClass}__person__info__contactInfo__phone`).empty().append($.parseHTML(phoneNumbersString));
		}
		else {
			$personDomElement.find(`.${self.options.baseClass}__person__info__contactInfo__phone`).remove();
		}

		// person email
		if (personData.email) {
			$personDomElement.find(`.${self.options.baseClass}__person__info__contactInfo__email`).text(personData.email);
		}
		else {
			$personDomElement.find(`.${self.options.baseClass}__person__info__contactInfo__email`).remove();
		}

	}

	// linkedin and vcard buttons
	if (!personData.linkedin && !personData.vcard) {
		$personDomElement.find(`.${self.options.baseClass}__person__info__links`).remove();
	}
	else {

		if (personData.vcard) {
			$personDomElement.find(`.${self.options.baseClass}__person__info__links__link--vcard`).attr('href', personData.vcard);
		}
		else {
			$personDomElement.find(`.${self.options.baseClass}__person__info__links__link--vcard`).remove();
		}

		if (personData.linkedin) {
			$personDomElement.find(`.${self.options.baseClass}__person__info__links__link--linkedin`).attr('href', personData.linkedin);
		}
		else {
			$personDomElement.find(`.${self.options.baseClass}__person__info__links__link--linkedin`).remove();
		}

	}

	// return the dom element
	return $personDomElement;

};

// this function handles pulsating the button indicate to the user that the filters have been changed
// and that the button needs to be clicked to run the filtering
Directory.prototype.pulsateButton = function() {

	var self = this;

	let activeClass = `${self.options.baseClass}__submitFiltersButton--active`;

	this.$filterButtonWrapper.addClass(activeClass);

};

// this function stops the button pulsating, it is typically used when the filters are submitted
Directory.prototype.stopButtonPulsate = function() {

	var self = this;

	let activeClass = `${self.options.baseClass}__submitFiltersButton--active`;

	this.$filterButtonWrapper.removeClass(activeClass);

};

export default Directory;
